import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const newCateBtn = {
    textAlign: "right"
};

export const cardHeader = {
    backgroundColor: Colors.primary,
    color: "white",
    fontWeight: "bold"
};

export const cardStyle = {
    backgroundColor: Colors.primary,
    color: "white"
};

export const hidden = {
    visibility: "hidden"
};
